// global-learmo-modal.component.ts
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { AnimatedLoaderType } from '../../models/animated-loader-type.enum';

@Component({
  selector: 'app-global-learmo-modal',
  templateUrl: './global-learmo-modal.component.html',
  styleUrls: ['./global-learmo-modal.component.css'],
})
export class GlobalLearmoModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() iconIcon: string = ''; // e.g. 'user-plus'
  @Input() loading: boolean = false;
  @Input() widthClass: string = 'max-w-lg'; // allow custom max-width

  // Dynamic Content Inputs (Merged from Unified Container)
  @Input() content: TemplateRef<any> | Type<any> | string | null = null;
  @Input() footer: TemplateRef<any> | string | null = null;
  @Input() transparent: boolean = false;
  @Input() noPadding: boolean = false;
  @Input() fullHeight: boolean = false; // For regular modals to fill height
  @Input() isFullscreen: boolean = false; // For fullscreen modals (90vh with backdrop)
  @Input() componentInputs: { [key: string]: any } = {};

  @Output() closed = new EventEmitter<void>();

  @ViewChild('componentContainer', { read: ViewContainerRef, static: false })
  componentContainer!: ViewContainerRef;

  innerComponentInstance: any = null;

  animatedLoaderType = AnimatedLoaderType;

  // Helper flags
  isTemplate = false;
  isComponent = false;
  isString = false;
  isFooterTemplate = false;

  ngOnInit() {
    this.isTemplate = this.content instanceof TemplateRef;
    this.isComponent = typeof this.content === 'function';
    this.isString = typeof this.content === 'string';
    this.isFooterTemplate = this.footer instanceof TemplateRef;

    // If it's a component, we will handle its creation in ngAfterViewInit
    // to ensure ViewChild is available
  }

  ngAfterViewInit() {
    if (this.isComponent && this.content) {
      this.createComponent();
    }
  }

  private createComponent() {
    if (!this.componentContainer) return;

    this.componentContainer.clear();
    const componentRef = this.componentContainer.createComponent(
      this.content as Type<any>
    );
    this.innerComponentInstance = componentRef.instance;

    // Pass inputs if any
    if (this.componentInputs) {
      Object.keys(this.componentInputs).forEach((key) => {
        this.innerComponentInstance[key] = this.componentInputs[key];
      });
    }

    // Auto-delegate footer if available in component
    if (this.innerComponentInstance.modalFooter && !this.footer) {
      this.footer = this.innerComponentInstance.modalFooter;
      this.isFooterTemplate = this.footer instanceof TemplateRef;
    }

    // Trigger change detection for the newly created component
    componentRef.changeDetectorRef.detectChanges();
  }

  close() {
    this.closed.emit();
  }
}
